import { useState } from 'react'
import { useTranslation } from 'next-i18next'

import Button from '~/components/Buttons/Button'
import { Link } from '~/components'
import bootcampAnalytics from '~/analytics/bootcamp/bootcampAnalytics'

export enum Tab {
  GRADE = 'grade',
  TOPIC = 'topic',
}

interface SelectToggleProps {
  gradeUrl: string
  topicUrl: string
  defaultTab: Tab
}

export default function SelectToggle({ gradeUrl, topicUrl, defaultTab }: SelectToggleProps): React.ReactElement {
  const { t } = useTranslation('onboarding')
  const [activeTab, setActiveTab] = useState<Tab>(defaultTab)

  const handleTabChange = (tab: Tab, from: Tab): void => {
    setActiveTab(tab)
    if (tab === Tab.GRADE) {
      bootcampAnalytics.logToggleSwitch(from, Tab.GRADE)
    } else {
      bootcampAnalytics.logToggleSwitch(from, Tab.TOPIC)
    }
  }
  return (
    <div className="flex justify-center items-center mt-8">
      <div className="relative flex shrink-0 justify-center items-center rounded-4 h-12 w-64 bg-white">
        <div
          className={`absolute top-1/2 -translate-y-1/2 left-2 h-9 w-30 bg-orange rounded-2.5 transform transition-transform duration-300 ease-in-out ${
            activeTab === Tab.GRADE ? 'translate-x-0' : 'translate-x-30'
          }`}
        />
        <div className="relative flex w-full">
          <Link
            className="flex justify-center items-center mx-4 my-auto text-xxs h-8 font-bold w-1/2 text-black rounded-2.5 focus:outline-none z-10"
            onClick={() => handleTabChange(Tab.GRADE, activeTab)}
            to={gradeUrl}
          >
            <Button>{t('curriculum.selectByGrade')}</Button>
          </Link>
          <Link
            className="flex justify-center items-center mr-4 my-auto text-xxs h-8 font-bold w-1/2 text-black rounded-2.5 focus:outline-none z-10"
            onClick={() => handleTabChange(Tab.TOPIC, activeTab)}
            to={topicUrl}
          >
            <Button>{t('curriculum.selectByTopic')}</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
